import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RenewalComponent } from './renewal.component';
const routes: Routes = [
  { path: '', component: RenewalComponent },
  { path: 'new', component: RenewalComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RenewalRoutingModule { }
